/**
 * Resource that represents a Production Order Row.
 *
 * @name ProductionOrderRow
 * @class$
 * @augments TmrResource
 */
let ProductionOrderRowFactory = function (
  TmrResource,
  ProductionOrder,
  Product
) {
  'ngInject'
  let referencedProperties = [
    // item.order property will be instantiated as a ProductionOrder resource
    { property: 'order', resource: ProductionOrder },
    // item.product property will be instantiated as a Product resource
    { property: 'product', resource: Product },
  ]

  let ProductionOrderRow = TmrResource(
    'ProductionOrderRow',
    {},
    referencedProperties,
    undefined,
    true
  )

  Object.assign(ProductionOrderRow.prototype, {
    /**
     * Override default label.
     *
     * @method ProductionOrderRow#$getLabel
     */
    $getLabel: function () {
      return `${this.order.$getLabel()} ${this.product.$getLabel()}`
    },
  })

  return ProductionOrderRow
}

export const factory = ['ProductionOrderRow', ProductionOrderRowFactory]
